export default {
	common: {
		noMore: "没有更多数据",
		noData: "暂无数据！",
		loading: "加载中...",
		gotIt: '知道了',
		confirm: "确定",
		cancel: "取消"
	},
	activity: {
		title: '活动',
		rule: '活动规则',
		stockNotEnough: '商品库存不足',
		soldOut: '商品已售罄',
		addCartSuccess: '加购成功',
		maxPurchaseLimit: '最多购买{num}个',
	},
	inivteFriends: {
		title: '邀请好友',
		earn: '赚取',
		for: '每',
		eachFriendInvited: '邀请一个朋友',
		myRewards: '我的奖励',
		received: '已领取',
		invited: '已邀请',
		shareNow: '立即分享',
		welcomeGift: '欢迎礼物',
		invitedFriends: '已邀请好友',
		noSuccessfulInvites: '暂无成功邀请',
		howItWorks: '如何使用',
	},
	document: {
		title: '文档',
	},
}
